<template>
  <v-container class="px-0">
    <Filters ref="filtersRef" :onFilter="onFilter" filtersType="2" />
    <v-row>
      <v-col cols="6">
        <Points ref="pointsRef" @update-point-father="updateSelected" />
      </v-col>
      <v-col cols="6">
        <v-card flat>
          <v-card-title primary-title>
            <v-icon left color="green darken-2">mdi-file-excel</v-icon>
            {{ $t("export") }}
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <Date-picker
                id="dateFrom"
                :rules="[rules.required]"  
                :timestamp="dateFrom" 
                label="Date From" 
                @update:timestamp="changeFilters"
              />
              <Date-picker
                id="dateTo" 
                :timestamp="dateTo" 
                label="Date To"
                @update:timestamp="changeFilters" 
              />
              <!--
               <v-select
                v-model="groupBy"
                :items="groupByItems"
                label="Group By"
                dense
                item-text="text"
                item-value="value"
                return-object
                required
                :disabled="groupByDisabled"
              >
              </v-select>
              <v-select
                v-model="fileFormat"
                :items="formats"
                label="Output format"
                dense
                item-text="text"
                item-value="value"
                return-object
                required
                @change="checkFormat"
              >
              </v-select>
              -->
            </v-form>
            <v-btn
              :disabled="!(valid && selectedPoints.length > 0 && dateFrom && dateTo && groupBy && fileFormat)"
              @click="scheduleExport()"
              color="success"
            >
              <v-icon>mdi-export</v-icon>&nbsp;Reserve Export
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card flat class="mt-4">
      <v-card-text>
        <p class="text-h5 text--primary">
          <v-icon left color="green darken-2">mdi-file-find</v-icon>
          Files available for download
        </p>

        <v-row>
          <v-col cols="12">
            <v-data-table :items="fileData" :headers="fileHeaders">
              <template v-slot:[`item.status`]="{ item }">
                  <v-chip
                    v-if="item.status === 'REQUEST'"
                    color="yellow darken-2"
                    text-color="white"
                  >
                    {{ item.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="item.status === 'WORKING'"
                    color="orange darken-2"
                    text-color="white"
                  >
                    {{ item.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="item.status === 'COMPLETED'"
                    color="green darken-2"
                    text-color="white"
                  >
                    {{ item.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="item.status === 'STOPPED'"
                    color="grey darken-2"
                    text-color="white"
                  >
                    {{ item.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="item.status === 'ERROR'"
                    color="red darken-2"
                    text-color="white"
                  >
                    {{ item.status }}
                  </v-chip>
              </template>


              <template v-slot:[`item.actions`]="{ item }">

                <div class="text-no-wrap">

                  <v-btn title="Delete" v-bind="item" @click="exportIdReady=item.exportId; showDeleteConfirm=true" text icon color="error">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>


                  <v-btn title="Download" v-if="item.status==='COMPLETED'" v-bind="item" @click="downloadExportFile(item.exportId);" text icon color="green darken-2">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>

                </div>  
                  

              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <Confirm 
      :show="showDeleteConfirm"
      message="Do you really want to delete this item?"
      title="Delete File"
      :onConfirm="onConfirmDelete"
      :onCancel="()=> showDeleteConfirm = false"
    />


  </v-container>
</template>


 

<script>
import Filters from "@/components/shared/Filters";
import Points from "@/components/shared/Points";
import DatePicker from "@/components/shared/DatePicker";
import Confirm from '@/components/shared/Confirm';
import { mapState } from 'vuex';

export default {
  name: "Export",
  components: {
    Filters,
    Points,
    DatePicker,
    Confirm
  },
  
  watch: {
    plantId(newVal, oldVal) {
      if(newVal !== oldVal){
        this.onFilter({
          type: this.$refs.filtersRef.type,
      });
      }
    },
  },

  data() {
    return {
      breadcrumbsItems: [
        {
          href: "/home",
          disabled: false,
          text: this.$t("home").toUpperCase(),
          to: "/home",
        },
        { href: "./", disabled: true, text: this.$t("export").toUpperCase() },
      ],
      dateTo: null,
      dateFrom: null,
      groupByDisabled: true,
      groupBy: "none",
      groupByMemory: '',
      groupByItems: [
        { text: "Message Type", value: "messageType" },
        { text: "Sensor", value: "sensorName" },
        { text: "None", value: "none" },
      ],
      //formats: [{ text: "csv", value: "csv" }, { text: "xlsx", value: "xlsx" }],
      formats: [{ text: "csv", value: "csv" }],
      fileFormat: "csv",
      fieldSeparator: ";",
      recordSeparator: String.raw`\n`,
      loading: false,
      valid: false,
      selectedPoints: [],
      fileHeaders: [
        // { text: "Export ID", value: "exportId", sortable: true },
        //{ text: "User ID", value: "userId", sortable: true },
        //{ text: "Plant ID", value: "plantId", sortable: true },
        { text: "File Name", value: "fileName", sortable: true },
        //{ text: "File Path", value: "filePath", sortable: true }, // for future use
        { text: "File Size (MB)", value: "fileSize", sortable: true }, // for future use
        //{ text: "File Format", value: "fileFormat", sortable: true },
        { text: "Creation Date", value: "creationDate", sortable: true },
        { text: "Update Date", value: "updateDate", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Message", value: "message", sortable: true },
        //{ text: "First Download", value: "firstDownload", sortable: true },
        //{ text: "Last Download Date", value: "lastDownloadDate", sortable: true },
        //{ text: "First Mail Sent", value: "firstMailSent", sortable: true },
        //{ text: "Last Mail Date", value: "lastMailDate", sortable: true }
        { text: "Actions", sortable: false, value: "actions" },
      ],
      fileData: [],  // data shown in GUI
      exportData: null,   // data used to export
      dateTimeFormat: this.$store.state.user.configParams.dateTimeFormat || 'dd/MM/yyyy hh:mm:ss',
      showDeleteConfirm: false,
      exportIdReady: null, // used to store exportId for delete confirmation
      exportCheckInterval: null,
    };
  },

  computed: {
    ...mapState(['plantId']),
    rules() {
      return this.$script.formRules;
    },    
  },

  mounted: function () {
    this.$store.dispatch("_updateBreadcrumbs", this.breadcrumbsItems);
    this.onFilter({
      type: this.$refs.filtersRef.type,
    });
    this.getExportFilesRecurrent();
  },

  beforeDestroy: function(){
    if (this.exportCheckInterval) {
      clearInterval(this.exportCheckInterval);
      this.exportCheckInterval = null;
    }
  },

  methods: {

    async getExportFilesRecurrent(){
      this.getExportFiles()
      
      this.exportCheckInterval = setInterval(() => {
        this.getExportFiles();
      }, 10000);
    },


    async onFilter({ area, element, structure, sensor, type }) {
      this.$refs.pointsRef.onFilter({
        area,
        element,
        structure,
        sensor,
        type,
      });
    },

    async changeFilters(event){
        
        // update date values
        if(event.id === "dateFrom" && this.dateFrom !== event.timestamp){
          this.dateFrom = event.timestamp;
        }

        if(event.id === "dateTo" && this.dateTo !== event.timestamp){
          this.dateTo = event.timestamp;
        }
    },

    async getExportFiles() {
      this.loading = true;
      
      let result = await this.$store.dispatch("_getExportFiles", {});

      // converts date from ISO to user format
      for (let record of result) {
        record.creationDate = this.$date.fromISO(record.creationDate).toFormat(this.dateTimeFormat);
        record.updateDate = this.$date.fromISO(record.updateDate).toFormat(this.dateTimeFormat);
        record.fileSize = Math.round(((record.fileSize/1024/1024) + Number.EPSILON) * 100) / 100
      }

      this.fileData = result;
      
      this.loading = false;
    },


    async scheduleExport() {

      if (!this.$refs.form.validate()) return;
      
      // by default groupBy is a string, if I use select it became an object
      const _groupBy = typeof this.groupBy === "string" ? this.groupBy :  this.groupBy.value;
      const _fileFormat = typeof this.fileFormat === "string" ? this.fileFormat :  this.fileFormat.value;

      let result = await this.$store.dispatch("_scheduleExport", {
        data: {
          pointList: this.selectedPoints.map((x) => {
            return x.sensorId;
          }),
          dateFrom: new Date(this.dateFrom).toISOString(),
          dateTo: new Date(this.dateTo).toISOString(),
          groupBy: _groupBy,
          fileformat: _fileFormat,      
          fieldSeparator: this.fieldSeparator,  
          recordSeparator: this.recordSeparator,  
        },
      });


      if(!result) {
        this.$store.dispatch("_snackbarMessage", {
          message: "Error on scheduling",
          status: "error",
        });
        return;
      } else {
        this.$store.dispatch("_snackbarMessage", {
          message: result.data.message,
          status: "success",
        });
      }

      // reload file list
      this.getExportFiles();
      
    },

    async onConfirmDelete(){
      this.showDeleteConfirm = false
      
      this.deleteExportFile(this.exportIdReady);
    },

    async downloadExportFile(exportId) {
      
      
      const result = await this.$store.dispatch("_downloadExportFile", { data: {exportId} });

      if(!result) {
        this.$store.dispatch("_snackbarMessage", {
          message: "Error on downloading file",
          status: "error",
        });
        return;
      }

      const blob = new Blob([result.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const headers = result.headers;
      const headersData = headers['content-disposition'].split(";");
      const filteredArray = headersData.filter((str)=>str.indexOf("filename") > -1);
      const fileName = filteredArray.length > 0 ? filteredArray[0].trim().replace("filename=", "").replace(/"/g, '') : 'export.xlsx';
      
      // Crea elemento <a> temporaneo per il download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

    //if (!response) return;

    //const { result, data } = response;

    //if (!result) return;

    //return data;


    },

    async stopExportFile(exportId) {
      await this.$store.dispatch("_stopExportFile", { data: {exportId} });
      this.getExportFiles();
    },

    async deleteExportFile(exportId) {
      await this.$store.dispatch("_deleteExportFile", { data: {exportId} });
      this.getExportFiles();
    },

    checkFormat(){
            
      if(this.fileFormat?.value === 'xlsx'){
        this.groupByDisabled = false;
        this.groupBy = this.groupByMemory;  
      } else {
        this.groupByMemory = this.groupBy;
        this.groupByDisabled = true;
        this.groupBy = 'none';
      }
    },

    updateSelected(items) {
      this.selectedPoints = items;
    },
    
  },
};
</script>
